import React, { Component } from 'react';
import ReactPlayer from 'react-player';

class VideoPlayer extends Component {
    render() {
      const { videoPath, videoTitle } = this.props;
  
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100vh' }}>
          <div style={{ marginBottom: '40px' }}>
            <ReactPlayer
              style={{ position: 'relative ', top: "5%", left: "0%" }}
              controls
              url={"video/".concat(videoPath)}
              playing
              width="100%"
              height="100%"
            />
          </div>
          {videoTitle && (
            <div style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center', whiteSpace: 'pre-line' }}>
              {videoTitle}
            </div>
          )}
        </div>
      );
    }
  }
  
  

export default VideoPlayer;
